import React from 'react';
import withIcon from '../utilities/withIcon';

const IconBooks = () => {
  return (
    <g>
      <path d="M14.2 15.2H1.8c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h12.4c.4 0 .8.3.8.8s-.4.8-.8.8zM3 12.8c-.4 0-.8-.3-.8-.8V1.5c0-.4.3-.8.8-.8s.8.3.8.8V12c0 .4-.3.8-.8.8zM6.9 12.8c-.4 0-.8-.3-.8-.8V1.5c0-.4.3-.8.8-.8s.8.3.8.8V12c-.1.4-.4.8-.8.8zM13 12.8c-.3 0-.7-.2-.7-.6L9.9 1.9c-.1-.4.1-.8.5-.9.4-.1.8.2.9.6l2.4 10.3c.1.4-.2.8-.6.9H13z" />
    </g>
  );
};

export default withIcon(IconBooks);
